<template>
  <div
    id="userChangePasswordModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ชื่อผู้ใช้งาน (Username):</label>
                      <input
                        disabled
                        id="userName"
                        name="userName"
                        v-model="userName"
                        type="text"
                        maxlength="20"
                        class="form-control"
                        placeholder="ชื่อผู้ใช้งาน (Username)"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>รหัสผ่าน:</label>
                      <input
                        id="password"
                        name="password"
                        v-model="password"
                        type="password"
                        maxlength="20"
                        class="form-control"
                        placeholder="รหัสผ่าน"
                      >
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ยืนยันรหัสผ่าน:</label>
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        v-model="confirmPassword"
                        type="password"
                        maxlength="20"
                        class="form-control"
                        placeholder="ยืนยันรหัสผ่าน"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> แก้ไขรหัสผ่าน
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      userName: null,
      password: null,
      confirmPassword: null
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#userChangePasswordModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังเปลี่ยนรหัสผ่าน กรุณารอสักครู่..."
      });

      let router = this.$router;
      axios
        .post("/Api/Users/ChangePassword", {
          userName: this.userName,
          password: this.password,
          confirmPassword: this.confirmPassword
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#userChangePasswordModal").modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  mounted() {
    let self = this;
    let router = this.$router;

    self.userName = this.$route.params.userId;

    // set validation rules
    $("#userChangePasswordModal form").validate({
      rules: {
        userName: "required",
        password: {
          required: true,
          minlength: 6
        },
        confirmPassword: {
          equalTo: "#password"
        }
      },
      messages: {
        userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
        password: {
          required: "กรุณากรอกรหัสผ่าน",
          minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
        },
        confirmPassword: {
          equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
        }
      }
    });

    $("#userChangePasswordModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/User/UserChangePassword.vue